import { Routes } from "@angular/router";
import { PAGE_URLS } from "src/app/core/models/general";

export const AuthenticationRoutes: Routes = [
  {
    path: PAGE_URLS.LOGIN,
    loadComponent: () =>
      import("./login-workflow/login-workflow.component").then(
        (m) => m.LoginWorkflowComponent,
      ),
  },
  {
    path: PAGE_URLS.EDIT_PASSWORD,
    loadComponent: () =>
      import("./password-expired/password-expired.component").then(
        (m) => m.PasswordExpiredComponent,
      ),
  },
  {
    path: PAGE_URLS.LOGIN_WITH_MICROSOFT,
    loadComponent: () =>
      import("./oauth-login/oauth-login.component").then(
        (m) => m.OAuthLoginComponent,
      ),
  },
  {
    path: PAGE_URLS.RECOVER_PASSWORD,
    loadComponent: () =>
      import("./recover-password/recover-password.component").then(
        (m) => m.RecoverPasswordComponent,
      ),
  },
  {
    path: PAGE_URLS.RESET_PASSWORD,
    loadComponent: () =>
      import("./reset-password/reset-password.component").then(
        (m) => m.ResetPasswordComponent,
      ),
  },
];
